/**
 * Utilitaire de logging conditionnel
 * Les logs sont affichés uniquement en développement
 * En production, ils sont masqués pour la sécurité
 */

const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';

const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  
  error: (...args) => {
    // Les erreurs sont toujours loggées mais sans données sensibles en prod
    if (isDev) {
      console.error(...args);
    } else {
      // En production, logger uniquement le message d'erreur générique
      const safeArgs = args.map(arg => {
        if (arg instanceof Error) return arg.message;
        if (typeof arg === 'object') return '[Object]';
        return arg;
      });
      console.error(...safeArgs);
    }
  },
  
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  
  // Pour forcer un log même en production (à utiliser avec précaution)
  force: (...args) => {
    console.log(...args);
  }
};

export default logger;

// Remplacer console.log globalement en production
if (!isDev) {
  // Sauvegarder les fonctions originales
  const originalConsole = {
    log: console.log,
    info: console.info,
    debug: console.debug,
    warn: console.warn
  };
  
  // Désactiver les logs non-erreurs en production
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  
  // Garder les warnings mais sans données sensibles
  console.warn = (...args) => {
    originalConsole.warn('[Warning]', args[0]);
  };
}
